<mat-progress-bar class="page-loader" [value]="loader.progress$|async" *ngIf="loader.progress$|async"
  [ngStyle]="{height: '2px'}">
</mat-progress-bar>
<div class="app" [dir]="options.dir" [ngClass]="{
  'app-dark': options.dark,
  'boxed': options.boxed,
  'collapsed-sidebar': options.collapsed,
  'side-panel-opened': sidePanelOpened,
  'side-panel-closed': !sidePanelOpened }">

  <vias-header (toggleSidenav)="toggleSidenav()"></vias-header>

  <mat-sidenav-container class="app-inner" (click)="updatePS()">

    <mat-sidenav #sidemenu class="sidebar-panel" [mode]="isOver() ? 'over' : 'side'" [opened]="!isOver()"
      (openedStart)="sidePanelOpened = true" (closedStart)="sidePanelOpened = false" [perfectScrollbar]="config"
      [disabled]="mediaMatcher.matches">
      <vias-nav></vias-nav>
    </mat-sidenav>

    <div [perfectScrollbar]="config" [disabled]="mediaMatcher.matches">
        <mat-card>
            <mat-card-content>
              <div>
                <vias-progress-spinner [run]="viasService.progressSpinnerRun"></vias-progress-spinner>
                <router-outlet [className]="routeData.css"></router-outlet>
              </div>
            </mat-card-content>
        </mat-card>
    </div>
  </mat-sidenav-container>

</div>